<template>
  <div id="practice-perform" :class="{open: opened, iphonex: app.config.style.iphonex}">
    <div id="practice-perform-content">
      <div class="perform-head">
        <div class="perform-exit" :title="app.strings.practice.perform.exit" v-on:click="exit()">
          <font-awesome-icon :icon="['fas', 'chevron-left']" />
        </div>
        <div class="perform-person">
          <b>{{ studentName }}</b>
          <span>{{ app.strings.practice.perform.until }} {{ endTime }}</span>
        </div>
      </div>
      <div class="perform-figures">
        <div id="practice-timer" :class="{'error-blink-background': offTime}">
        {{ practice.time.elapsed[1] | fillZero(1) }} : {{ practice.time.elapsed[2] | fillZero(1) }} : {{ practice.time.elapsed[3] | fillZero(1) }}
      </div>
        <div class="perform-mean" :class="'evaluation-' + meanLevel" v-if="mean !== ''">{{ mean }}<small>%</small></div>
      </div>
      <div id="practice-buttons">
        <div>
          <div v-on:click="practice.comments.opened = true">
            <div>
              <font-awesome-icon class="icon clear" :icon="['far', 'comment-alt']" /> <span>{{ practice.comments.data.length }}</span>
              <small>{{ app.strings.practice.perform.notes }}</small>
            </div>
          </div>
          <div>
            <div :class="{selected: withoutPracticed, disabled: !withoutPracticed && withoutPracticedCount === 0}" v-on:click="togglePracticeView()">
              <font-awesome-icon class="icon clear" :icon="['fas', 'exclamation-triangle']" /> <span>{{ withoutPracticedCount }}</span>
              <small>{{ app.strings.practice.perform.unpracticed }}</small>
            </div>
          </div>
          <div>
            <div v-on:click="openReport">
              <font-awesome-icon class="icon clear" :icon="['far', 'file']" />
              <small>{{ app.strings.practice.perform.report }}</small>
            </div>
          </div>
        </div>
      </div>
      <student-evaluation-practice-component :show-mean="false" v-on:onMean="(value, level) => { mean = value; meanLevel = level }" v-on:onChange="rc++" :app="app" :student="this.practice.data.student" :evaluation="evaluation" :withoutPracticed="withoutPracticed" @onPractice="withoutPracticed = false" :editable="true" />
      <!-- Sticky at the bottom: the whole screen scrolls, not the list. -->
      <div class="perform-end-bar">
        <button class="h-button w-100 danger" v-on:click="practiceEnd()">
          {{ app.strings.practice.perform.end }}
        </button>
      </div>
    </div>

    <div id="student-comments" :class="{open: practice.comments.opened}">
      <div id="student-comments-content">
        <div class="title">
          <div v-on:click="practice.comments.opened = false">
            <div>
              <font-awesome-icon class="icon clear" :icon="['far', 'comment-alt']" />
            </div>
            <div>{{ app.strings.practice.perform.comments }}</div>
            <div>
              <div>{{ practice.comments.data.length }}</div>
            </div>
            <div class="comments-close">
              <font-awesome-icon :icon="['fas', 'times']" />
            </div>
          </div>
        </div>
        <div id="student-comments-list">
          <div class="comments-empty" v-if="practice.comments.data.length === 0">{{ app.strings.practice.perform.no_comments }}</div>
          <div :class="'comment-' + comment.inserted_at" v-for="comment in practice.comments.data" v-bind:key="comment.id">
            <div>
              {{ comment.inserted_at | humanDate }}
            </div>
            <div>
              {{ comment.comment }}
            </div>
          </div>
        </div>
        <div id="student-comments-form">
          <p>
            <textarea ref="comments-input" class="h-textarea white w-100 no-resize" v-model="practice.comments.input"></textarea>
          </p>
          <p>
            <button class="h-button default w-100" v-on:click="practiceCommentCreate" v-if="!practice.comments.loading">
              {{ app.strings.practice.perform.add_comment }}
            </button>
            <button class="h-button default w-100" v-else>
              <loader-dot :size="'16px'" :color_1="'rgb(255, 255, 255)'" :color_2="'rgb(255, 255, 255)'" />
            </button>
          </p>
        </div>
      </div>
    </div>

    <student-dgt-report-component ref="student-report" :app="app" />
  </div>
</template>

<script>
export default {
  name: 'practice-perform-view',
  data () {
    return {
      rc: 0,
      opened: false,
      withoutPracticed: false,
      mean: '',
      meanLevel: '',
      practice: {
        student: {},
        time: {
          elapsed: [0,0,0,0]
        },
        data: {
          started_at: new Date()
        },
        evaluation: {
          data: [],
          student: {
            data: []
          }
        },
        comments: {
          loading: false,
          opened: false,
          input: '',
          data: []
        }
      },
      evaluation: {
        groups: []
      }
    }
  },
  computed: {
    studentName () {
      let s = this.practice.student
      return [s.first_name, s.last_name_1, s.last_name_2].filter(Boolean).join(' ')
    },
    endTime () {
      let d = this.practice.data
      let minutes = (parseInt(d.hour) * 60 + parseInt(d.minute) + parseInt(d.time)) % 1440
      if (isNaN(minutes)) {
        return ''
      }
      let two = (n) => (n < 10 ? '0' : '') + n
      return two(Math.floor(minutes / 60)) + ':' + two(minutes % 60)
    },
    offTime () {
      return this.diffMinutes(this.practice.data.started_at, new Date()) > this.practice.data.time
    },
    withoutPracticedCount () {
      let count = this.rc
      count = 0

      for (let i in this.evaluation.groups) {
        let group = this.evaluation.groups[i]
        for (let j in group.items) {
          let item = group.items[j]
          if (item.value === 1) {
            count++
          }
        }
      }

      return count
    }
  },
  props: {
    app: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    setInterval(() => {
      this.practice.time.elapsed = this.dateFineDiff(this.practice.data.started_at, -1)
    }, 1000)
  },
  methods: {
    open (practice, evaluation) {
      this.practice.data = practice.data
      this.practice.student = practice.student
      this.practice.evaluation.data = evaluation.data
      this.practice.evaluation.student.data = evaluation.student.data

      this.updateEvaluationValues()
      this.practiceCommentRead()

      this.opened = true
    },
    close () {
      this.opened = false
    },
    // The class keeps running; it comes back from its page.
    exit () {
      this.close()
      this.$router.push({name: 'app.teacher.practice.menu', params: {id: this.practice.data.id}, query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
    },
    updateEvaluationValues () {
      for (let i in this.practice.evaluation.data) {
        let evaluation = this.practice.evaluation.data[i]
        for (let j in evaluation.groups) {
          let group = evaluation.groups[j]
          for (let u in group.items) {
            let item = group.items[u]
            group.items[u].value = 1
            for (let i in this.practice.evaluation.student.data) {
              let evaluation = this.practice.evaluation.student.data[i]
              if (evaluation.item === item.id && evaluation.business_id === item.business_id) {
                group.items[u].value = evaluation.value
              }
            }
          }
        }
      }

      for (let i in this.practice.evaluation.data) {
        if (parseInt(this.practice.evaluation.data[i].id) === parseInt(this.practice.data.evaluation.id) && parseInt(this.practice.evaluation.data[i].business_id) === parseInt(this.practice.data.evaluation.business_id)) {
          this.evaluation = this.practice.evaluation.data[i]
        }
      }
    },
    practiceEnd () {
      this.$swal({
        title: this.app.strings.practice.perform.end_confirm.title,
        text: this.app.strings.practice.perform.end_confirm.content,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.app.strings.common.cancel,
        confirmButtonText: this.app.strings.common.confirm
      }).then((result) => {
        if (result.value) {
          this.close()
          this.$emit('onEnd')
        }
      })
    },
    togglePracticeView () {
      if (this.withoutPracticedCount === 0) {
        this.withoutPracticed = false
      } else {
        this.withoutPracticed = !this.withoutPracticed
      }
    },
    practiceCommentRead () {
      if (this.practice.comments.loading) {
        return
      }

      this.practice.comments.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.practice.comment.read.all + '?student=' + this.practice.data.student,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.practice.comments.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.practice.comments.data = response.body.data.comments
            if (this.practice.comments.data.length > 0) {
              let comment = this.practice.comments.data[this.practice.comments.data.length - 1]
              for (let i = 0; i <= 5; i++) {
                setTimeout(() => {
                  const el = this.$el.getElementsByClassName('comment-' + comment.inserted_at)[0]

                  if (el) {
                    el.scrollIntoView()
                  }
                }, i * 100)
              }
            }
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-comment-read-all', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.practice.comments.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    practiceCommentCreate () {
      if (this.practice.comments.input.length === 0) {
        return
      }

      if (this.practice.comments.loading) {
        return
      }

      this.practice.comments.loading = true

      this.$http.post(
        this.app.url.api + this.app.endpoints.practice.comment.create,
        {
          id: this.practice.data.id,
          student: this.practice.data.student,
          comment: this.practice.comments.input
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.practice.comments.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.practice.comments.input = ''
            this.practiceCommentRead()
            this.$refs['comments-input'].focus()
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-comment-create', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.practice.comments.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    openReport () {
      this.$refs['student-report'].open(this.app.url.api + '/practice/report/' + this.practice.data.license + '/' + this.practice.data.circuit + '/' + this.practice.data.student + '?token=' + this.app.token, this.app.strings.app.student.dgtreport.title + ' · ' + this.app.strings.app.student.dgtreport.license.replace('{l}', this.practice.data.license))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#practice-perform {
  position: fixed;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  transition: top .5s;
}

#practice-perform.open {
  top: 0;
}

// Its own stacking context: the end bar must stay under the report.
#practice-perform-content {
  position: relative;
  z-index: 0;
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: linear-gradient(180deg, #f6f8fb 0%, #eef3f9 100%);
  padding: 14px 16px 0;
  box-sizing: border-box;
  flex-direction: column;
}

.perform-head {
  display: flex;
  flex: none;
  align-items: center;
  gap: 4px;
  margin-bottom: 10px;
}

.perform-exit {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #475569;
  font-size: 18px;
  cursor: pointer;
}

.perform-person {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.perform-person > b {
  overflow-wrap: anywhere;
  color: #0f172a;
  font-family: 'Lexend', sans-serif;
  font-size: 16px;
}

.perform-person > span {
  color: #64748b;
  font-size: 13px;
}

.perform-figures {
  display: flex;
  flex: none;
  align-items: stretch;
  gap: 8px;
}

.perform-figures > #practice-timer {
  flex: 1;
  min-width: 0;
}

.perform-mean {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  background-color: #FFFFFF;
  color: #475569;
  font-family: 'Lexend', sans-serif;
  font-size: 20px;
  font-weight: 700;
}

.perform-mean > small {
  margin-left: 1px;
  font-size: 12px;
}

.comments-close {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: #475569;
  font-size: 18px;
}

.comments-empty {
  padding: 24px 12px;
  color: #64748b;
  font-size: 14px;
  text-align: center;
}

// The skills list grows with its content; the screen scrolls instead.
#practice-perform-content ::v-deep #practice-view-evaluation {
  flex: none;
  overflow: visible;
}

.perform-end-bar {
  position: sticky;
  bottom: 0;
  z-index: 5;
  flex: none;
  margin-top: 8px;
  padding: 18px 0 16px;
  background: linear-gradient(180deg, rgba(238, 243, 249, 0) 0%, #eef3f9 35%);
}

.perform-end-bar > .h-button {
  margin: 0;
}

#practice-perform.iphonex > #practice-perform-content {
  padding-top: 65px !important;
}

#practice-timer {
  display: block;
  padding: 12px 24px;
  background-color: $color-primary-1;
  box-sizing: border-box;
  border-radius: 6px;
  text-align: center;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: bold;
}

#practice-buttons {
  flex: none;
  width: 100%;
  padding: 8px 0 0;
  box-sizing: border-box;
}

#practice-buttons > div {
  display: flex;
  gap: 8px;
  width: 100%;
}

#practice-buttons > div > div {
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
}

#practice-buttons > div > div > div {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: 62px;
  padding: 8px 4px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  column-gap: 6px;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(20, 67, 107, 0.08);
}

#practice-buttons > div > div > div .icon {
  font-size: 20px;
}

#practice-buttons > div > div:nth-of-type(1) > div {
  background-color: #FFFFFF;
}

#practice-buttons > div > div:nth-of-type(1) > div .icon {
  color: #2071b7;
}

#practice-buttons > div > div:nth-of-type(2) > div {
  background-color: #FFFFFF;
}

#practice-buttons > div > div:nth-of-type(2) > div .icon {
  color: #d97706;
}

#practice-buttons > div > div:nth-of-type(2) > div.selected {
  background-color: #d97706;
  border-color: #d97706;
}

#practice-buttons > div > div:nth-of-type(2) > div.selected .icon,
#practice-buttons > div > div:nth-of-type(2) > div.selected span {
  color: #FFFFFF;
}

#practice-buttons > div > div:nth-of-type(2) > div.disabled {
  opacity: 0.5;
}

#practice-buttons > div > div:nth-of-type(3) > div {
  background-color: #FFFFFF;
}

#practice-buttons > div > div:nth-of-type(3) > div .icon {
  color: $text-color-2;
}

#practice-buttons > div > div > div > span {
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

#practice-buttons > div > div > div > small {
  flex: 0 0 100%;
  margin-top: 2px;
  color: #475569;
  font-size: 12px;
  text-align: center;
}

#practice-buttons > div > div:nth-of-type(2) > div.selected small {
  color: #FFFFFF;
}

#student-comments {
  position: fixed;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  padding-top: 120px;
  box-sizing: border-box;
  background-color: rgba(15, 23, 42, 0.4);
  transition: top .5s;
}

#student-comments.open {
  top: 0;
}

#student-comments-content {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #f6f8fb;
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -12px 30px rgba(2, 6, 23, 0.18);
  box-sizing: border-box;
  flex-direction: column;
  overflow: hidden;
}

#student-comments-content .title {
  padding: 16px 20px 8px;
  box-sizing: border-box;
}

#student-comments-content .title > div {
  display: flex;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  border-radius: 16px;
  align-items: center;
  cursor: pointer;
}

#student-comments-content .title > div > div {
  padding: 12px;
}

#student-comments-content .title > div > div:nth-of-type(1) {
  color: $color-primary-1;
  font-size: 26px;
}

#student-comments-content .title > div > div:nth-of-type(2) {
  flex: 1;
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
  font-weight: 600;
  font-size: 15px;
}

#student-comments-content .title > div > div:nth-of-type(3) > div {
  display: flex;
  background-color: $color-primary-1;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  color: #FFF;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
}

#student-comments-list {
  flex: 1;
  padding: 25px;
  box-sizing: border-box;
  overflow: auto;
}

#student-comments-list > div {
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  padding: 12px 14px;
  box-sizing: border-box;
  margin: 8px 0;
}

#student-comments-list > div > div:nth-of-type(1) {
  color: #64748b;
  font-family: 'Lexend', sans-serif;
  font-size: 12px;
  font-weight: 700;
}

#student-comments-list > div > div:nth-of-type(2) {
  color: $text-color-1;
  font-size: 14px;
}

#student-comments-form {
  background-color: #FFFFFF;
  border-top: 1px solid #e8edf3;
  padding: 0px 20px;
  box-sizing: border-box;
}

#student-comments-form > div {

}

@media (min-width: 1024px) {
  // Beside the side menu, content centered.
  #practice-perform,
  #student-comments {
    left: 264px;
    width: calc(100% - 264px);
  }

  #practice-perform-content {
    padding: 32px;
  }

  #practice-perform-content > * {
    width: 100%;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  #student-comments-content {
    max-width: 760px;
    margin: 0 auto;
  }
}
</style>
